import 'uni-pages';import '@dcloudio/uni-stat';

import Vue from 'vue'            
import Page from './pages/personalCenter/myIntegral/integralDetails.vue'
createPage(Page)